import { trackView } from '@archetelos/lib/analytics';
import { useEffect } from 'react';

/**
 * Fire one anonymous lane-1 view on mount (Native Analytics, Spec 22). Anonymous
 * ALWAYS — even a signed-in user's view carries no id. This is a DIFFERENT lane
 * from useTimeTracking (aggregate popularity, not per-user seconds); do not
 * couple them.
 */
export function useTrackView(contentId: string | undefined): void {
  useEffect(() => {
    if (!contentId) return;
    trackView({ surface: 'app', contentId });
  }, [contentId]);
}
